import * as React from 'react';
import * as classNames from 'classnames';

export type ButtonColor =
	'blue'
	| 'mediumblue'
	| 'green'
	| 'yellow'
	| 'mediumyellow'
	| 'red'
	| 'lightred'
	| 'bluegray'
	| 'cancel'
	| 'link';

interface ButtonProps {
	className?: string;
	color?: ButtonColor;
	size?: 'large' | 'small';
	disabled?: boolean;
	onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export default class Button extends React.Component<ButtonProps, {}> {

	public render() {
		const className = classNames(
			'button',
			this.props.className,
			this.props.color,
			this.props.size,
			{disabled: this.props.disabled});
		return <button
			type='button'
			className={className}
			disabled={this.props.disabled}
			onClick={this.props.onClick}
		>
			{this.props.children}
		</button>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/Button.tsx